import { ai2htmlResize } from './utils/ai2html-resizer';

ai2htmlResize('#g-lizard-diagram-box');
